var SENTRY_RELEASE;SENTRY_RELEASE={name: "Unistocks", version: "2.2.2"};